import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

const isZoomKey = (evt) => {
  const key = String(evt.key || '').toLowerCase();
  return (
    key === '+' ||
    key === '-' ||
    key === '=' ||
    key === '_' ||
    key === '0' ||
    key === 'add' ||
    key === 'subtract' ||
    key === 'numpadadd' ||
    key === 'numpadsubtract' ||
    evt.code === 'NumpadAdd' ||
    evt.code === 'NumpadSubtract'
  );
};

const blockZoomShortcuts = (evt) => {
  if ((evt.ctrlKey || evt.metaKey) && isZoomKey(evt)) {
    evt.preventDefault();
  }
};

const blockWheelZoom = (evt) => {
  if (evt.ctrlKey || evt.metaKey) {
    evt.preventDefault();
  }
};

window.addEventListener('keydown', blockZoomShortcuts);
window.addEventListener('wheel', blockWheelZoom, { passive: false });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
